import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder
} from '@angular/forms';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faAt,
  faCheckCircle,
  faDollar,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { Subject, distinctUntilChanged, finalize, takeUntil } from 'rxjs';
import { selectUser } from '../../../ngrx/data.reducer';
import { CommonService } from '../../../services/common.service';
import { HelperService } from '../../../services/helper.service';
import { HttpService } from '../../../services/http.service';
import { LoaderService } from '../../../services/loader.service';
import { ModalService } from '../../../services/modal.service';
import { ResizeService } from '../../../services/resize.service';
import { InputComponent } from '../../input/input.component';
import { MiniLoadingComponent } from '../../loaders/mini-loader/mini-loading.component';
import { ModalComponent } from '../../modals/modal/modal.component';
import { PaymentModalComponent } from '../payment-modal/payment-modal.component';
import { DirectivesModule } from '../../../tsExtras/directives.module';

@Component({
  standalone: true,
  imports: [
    FontAwesomeModule,
    LazyLoadImageModule,
    MiniLoadingComponent,
    CommonModule,
    NgbTooltipModule,
    PaymentModalComponent,
    ModalComponent,
    DirectivesModule,
    InputComponent,
  ],
  selector: 'app-package-modal',
  templateUrl: './package-modal.component.html',
  styleUrls: ['./package-modal.component.scss'],
})
export class PackageModalComponent implements OnInit {
  @Input() screenWidth: any;
  @Input() contactId: any;
  @Input() chatDetails: any;
  @Output() viewUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() receiverInfo: any;
  faCheckCircle = faCheckCircle;
  faTimes = faTimes;
  faDollar = faDollar;
  faAt = faAt;
  @Input() bundleLoader: boolean = false;
  @Input() packages;
  shortListBundle;
  selectedBundle;
  pgModal: boolean = false;
  currentUrl: string;
  user$ = this.store.select(selectUser);
  private destroy$ = new Subject<void>();
  guestEmail;
  userDetails;
  clickedOnSubmit: boolean = false;
  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    private modalService: ModalService,
    private http: HttpService,
    private commonService: CommonService,
    private router: Router,
    private store: Store,
    public resize: ResizeService,
  ) {
    this.user$
    .pipe(
      takeUntil(this.destroy$),
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)))
    .subscribe((user) => {
      if (user) {
        this.userDetails = user;
      }
    });
    this.modalService.getModalStateObservable()
    .pipe(
      takeUntil(this.destroy$),
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)))
    .subscribe((state: any) => {
      this[state?.id] = state?.show;
    });
  }
  ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.selectedBundle = JSON.parse(
      localStorage.getItem('selectedPackage') || null,
    );
    if (this.selectedBundle) {
      this.submit();
    }
  }
  ngOnDestroy(): void {
    this.helper.removeGuestUser();
    this.destroy$.next();
    this.destroy$.complete();
    if (!this.clickedOnSubmit) {
      localStorage.removeItem('selectedPackage');
    }
  }
  submit() {
    setTimeout(() => {
      if (this.userDetails) {
        this.redirecToStripe();
      } else {
        this.helper.hideModal();
        this.viewUpdate.emit(false);
        this.helper.showModal(true, 'guestEmail');
      }
    }, 500);
  }
  async redirecToStripe() {
    if (this.selectedBundle?.price) {
      const guestUser = JSON.parse(localStorage.getItem('guestUser'));
      this.sendProductSelectEvent(this.selectedBundle?.price);
      this.http
        .loaderGet(
          `api/product/package/subscription/checkout/${this.selectedBundle?.id}`,
          true,
          true,
          true,
        )
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            LoaderService.loader.next(false);
            localStorage.removeItem('selectedPackage');
          }),
          distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))
        )
        .subscribe(
          (response) => {
            const data = {
              amount: this.selectedBundle?.price,
              productDetails: this.selectedBundle?.name,
              product: 'Packages',
              paymentGateway: 'Stripe',
              paymentMethod: 'Master Card',
              creatorName: this.receiverInfo?.fullName,
              username: this.receiverInfo?.mentorDetails?.[0]?.userName,
            };
            localStorage.setItem('packagesBuy', JSON.stringify(data));
            window.open(response?.model?.url, '_self');
          },
          (err) => {
            if (guestUser) {
              this.helper.removeGuestUser();
            }
            this.helper.hideModal();
            setTimeout(() => {
              this.viewUpdate.emit(false);
            }, 500);
          },
        );
    }
  }
  sendProductSelectEvent(price) {
    this.commonService.pixelAction(
      'Product Select',
      this.receiverInfo?.id,
      this.currentUrl,
      this.receiverInfo?.fullName?.toLowerCase(),
      'Packages',
      price,
      this.receiverInfo?.email?.toLowerCase(),
      null,
      null,
      null,
      null,
      this.receiverInfo?.mentorDetails?.[0]?.uniqueName,
    );
  }
  changePackage(selectedPackage: any) {
    localStorage.setItem('selectedPackage', JSON.stringify(selectedPackage));
    this.selectedBundle = selectedPackage;
  }
}
